<template>
  <base-wrapper>
    <base-card title="Laporan Penjualan" class="space-y-4">
      <div class="flex items-center justify-end gap-x-4">
        <base-input
          type="date"
          label="Dari"
          with-label
          :shadow="false"
          v-model="filter.fromDate"
          @change="loadOrderBundles"
        />

        <base-input
          type="date"
          label="Sampai"
          with-label
          :shadow="false"
          v-model="filter.toDate"
          @change="loadOrderBundles"
        />
        <base-input
          label="Search"
          type="text"
          placeholder="Cari kode"
          :shadow="false"
          debounce
          v-model="filter.search"
          @native-input="loadOrderBundles"
        />
        <base-button :to="{ name: 'laporan-penjualan-sc.tambah' }">
          <Icon icon="heroicons:plus-20-solid" class="h-5 w-5" />
          Buat Laporan
        </base-button>
      </div>

      <datatable
        :columns="[
          { id: 'code', name: 'Nomor Laporan' },
          { id: 'total', name: 'Total Laporan', theadClass: 'text-right' },
          { id: 'status', name: 'Dikirim', theadClass: 'text-center' },
          {
            id: 'validation',
            name: 'Validasi Pusat',
            theadClass: 'text-center',
          },
        ]"
        :total="orderBundles.meta.page.total"
        :perPage="orderBundles.meta.page.perPage"
        :currentPage="orderBundles.meta.page.currentPage"
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="orderBundle in orderBundles.data"
            :key="orderBundle.id"
            :class="[classes.tr, 'cursor-pointer hover:bg-green-100']"
            @click="onClickDetail(orderBundle)"
          >
            <td :class="classes.td">
              <p class="font-bold text-gray-900">
                {{ orderBundle.attributes.code }}
              </p>
              <p>{{ orderBundle.attributes.description }}</p>
              <p>{{ orderBundle.attributes.createdAt | formatDate }}</p>
            </td>
            <td :class="[classes.td, 'text-right']">
              <p>
                {{ orderBundle.attributes.bundle_report_price | toCurrency }}
              </p>
            </td>
            <td :class="[classes.td, 'text-center']">
              <base-badge
                :color="orderBundle.attributes.is_submitted ? 'green' : 'red'"
                >{{
                  orderBundle.attributes.is_submitted
                    ? 'Dikirim'
                    : 'Belum Terkirim'
                }}</base-badge
              >
            </td>
            <td :class="[classes.td, 'text-center']">
              <base-badge
                :color="getOrderBundleStatus(orderBundle).color"
                >{{
                  getOrderBundleStatus(orderBundle).text
                }}</base-badge
              >
            </td>
          </tr>
        </template>

        <template v-if="orderBundles.data.length" #tfoot="{ classes }">
          <tr :class="[classes.tr, 'bg-gray-50']">
            <td :class="classes.td">Total Penjualan</td>
            <td :class="[classes.td, 'text-right']">
              {{ orderBundles.meta.total_bundle_report_price | toCurrency }}
            </td>
            <td colspan="2"></td>
          </tr>
        </template>
      </datatable>
    </base-card>

    <view-order-bundle-modal
      :visible="detailModal.visible"
      :order-bundle-id="detailModal.id"
      @close="detailModal.visible = false"
      @deleted="loadOrderBundles"
      @submitted="loadOrderBundles"
    />

    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import BaseInput from '@/components/base/BaseInput';
import ViewOrderBundleModal from '@/components/order-bundles/view-order-bundle-modal.vue';
import dayjs from 'dayjs';
import BaseButton from '@/components/base/BaseButton.vue';
import { requestMixin } from '../../../../mixins/request/request';
import { mapGetters } from 'vuex';

export default {
  mixins: [requestMixin],
  components: {
    BaseInput,
    BaseButton,
    ViewOrderBundleModal,
  },
  data() {
    return {
      detailModal: {
        id: null,
        visible: false,
      },
      filter: {
        search: null,
        fromDate: null,
        toDate: null,
      },
      loading: false,
      orderBundles: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
  },
  methods: {
    dayjs,
    getOrderBundleStatus(orderBundle) {
      if (orderBundle.attributes.is_canceled) {
        return {
          color: 'red',
          text: 'Dibatalkan'
        }
      }

      if (orderBundle.attributes.is_validated) {
        return {
          color: 'green',
          text: 'Tervalidasi'
        }
      }

      return {
        color: 'yellow',
        text: 'Belum Tervalidasi'
      }
    },
    async loadOrderBundles(params) {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/order-bundles`, {
        params: {
          'filter[office_type]': 'stockist_center',
          'fields[order-bundles]':
            'code,description,createdAt,bundle_report_price,is_submitted,is_validated,is_canceled',
          'filter[fromDate]': this.filter.fromDate,
          'filter[toDate]': this.filter.toDate,
          'filter[search]': this.filter.search,
          'page[size]': 5,
          ...params,
        },
      });

      if (!err) {
        this.orderBundles = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadOrderBundles({
        'page[number]': page,
      });
    },
    onClickDetail(orderBundle) {
      this.detailModal.id = orderBundle.id;
      this.detailModal.visible = true;
    },
    async setDefaultFilterDate() {
      this.filter.fromDate = dayjs(this.me.current_period.start_date).format(
        'YYYY-MM-DD'
      );
      this.filter.toDate = dayjs(this.me.current_period.end_date).format(
        'YYYY-MM-DD'
      );
    },
  },
  created() {
    this.setDefaultFilterDate();
    this.loadOrderBundles();
  },
};
</script>
